/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

import { PropertyOperator } from './propertyOperator.zod'

export const WidgetFilterEntry = /* @__PURE__ */ zod.object({
    filterId: zod.string().min(1),
    propertyName: zod.string().min(1),
    optionId: zod.string().min(1),
    operator: PropertyOperator,
    value: zod.union([zod.string(), zod.array(zod.string()), zod.null()]).optional(),
})

export type WidgetFilterEntry = zod.input<typeof WidgetFilterEntry>
export type WidgetFilterEntryOutput = zod.output<typeof WidgetFilterEntry>
